import { useState, useEffect } from 'react';
import { useAuth } from '@/lib/auth';
import { api } from '@/lib/api';
import { ListingCard } from '@/components/ListingCard';
import { Heart } from 'lucide-react';
import { SEO } from '@/components/SEO';

export default function FavoritesPage() {
  const { user } = useAuth();
  const [listings, setListings] = useState([]);
  const [favoriteIds, setFavoriteIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getFavorites()
      .then(r => {
        setListings(r.data.listings || []);
        setFavoriteIds(r.data.favorite_ids || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in" data-testid="favorites-page">
      <SEO
        title="My Favorites"
        description="View and manage your saved dog listings on DoggoHub."
      />
      <div className="mb-8">
        <h1 className="font-['Nunito'] font-extrabold text-3xl sm:text-4xl text-[#1A1D20] tracking-tight">
          My Favorites
        </h1>
        <p className="text-sm text-[#5C636A] mt-1">
          Dogs you've saved for later
        </p>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-white rounded-3xl overflow-hidden animate-pulse">
              <div className="aspect-square bg-gray-200" />
              <div className="p-5 space-y-3">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-3 bg-gray-200 rounded w-1/2" />
              </div>
            </div>
          ))}
        </div>
      ) : listings.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="favorites-grid">
          {listings.map((listing) => (
            <ListingCard key={listing.listing_id} listing={listing} isFavorited={true} />
          ))}
        </div>
      ) : (
        <div className="text-center py-20" data-testid="no-favorites-message">
          <Heart className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-[#5C636A] text-lg mb-2">No favorites yet</p>
          <p className="text-sm text-[#5C636A]">Browse the marketplace and save dogs you love</p>
        </div>
      )}
    </div>
  );
}
